import React from 'react';
import './Logout.css';
import useLogout from "../../hooks/useLogout";

const LogoutComponent = () => {
    const logout = useLogout();

    const handleButtonClick = () => {
        logout();
    };

    return (
        <div className="logout-container">
            <p className="logout-message">¿Estás seguro que quieres cerrar sesión?</p>
            <button className="logout-button" onClick={handleButtonClick}>
                Cerrar sesión
            </button>
        </div>
    );
};

export default LogoutComponent;